<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/sjkd/zbgg">招标公告</router-link> >
      <router-link to="/sjkd/zbgg/list?type=zb">招标产品公告</router-link> >
      {{ current.title }}
    </div>

    <div class="container-width">
      <ARTICLE :current="current" :page="currentPage"></ARTICLE>
    </div>
  </div>
</template>
<script>
import service from "../../../service/index";
import BANNER from "../../../components/banner/sjkd";
export default {
  name: "ZBARTICLE",
  data() {
    return {
      navigationData: [
        {
          name: "招标公告",
          path: "/sjkd/zbgg",
        },
      ],
      currentPath: "/sjkd/zbgg",
      currentPage: "zbcpgg", //文章组件 用来判断
      current: {
        title: "",
        description: "",
        releaseDate: "",
        views: "",
        origin: "",
        fujianids: "",
      },
      applyContent: {
        name: "",
        tel: "",
        companyName: "",
        companyAddress: "",
        companytel: "",
      },
      applyStatus: false, //填写内容状态
      // 上一篇
      before: {
        title: "",
        id: "",
        active: false,
      },
      // 下一篇
      after: {
        title: "",
        id: "",
        active: false,
      },
      showorigin: true,
      showBeforeAfter: false,
    };
  },
  components: { BANNER },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let parmes = {
        id: this.$route.query.id,
      };
      service.getwzBiddingNoticeInfo(parmes, (res) => {
        res.releaseDate = res.releaseDate;
       

        res.productExplain = res.productExplain.replace(
          /<table[^>]*>/gi,
          function (match, capture) {
            return match.replace(/width=\"(.*)\"/gi, "style='width:90%'");
          }
        );
        this.current = { ...res };
      });
    },
    applyTo() {
      if (this.applyContent.companyName == "") {
        this.$message({
          message: "请先输入公司名称",
          type: "warning",
        });
        return;
      }
      if (this.applyContent.companyAddress == "") {
        this.$message({
          message: "请先输入公司所在地",
          type: "warning",
        });
        return;
      }
      if (this.applyContent.companytel == "") {
        this.$message({
          message: "请先输入联系人",
          type: "warning",
        });
        return;
      }
      if (this.applyContent.name == "") {
        this.$message({
          message: "请先输入联系人姓名",
          type: "warning",
        });
        return;
      }
      if (this.applyContent.tel == "") {
        this.$message({
          message: "请先输入联系电话",
          type: "warning",
        });
        return;
      }
      this.applyStatus = true;

      let params = {
        bidId: this.$route.query.id,
        compName: this.applyContent.companyName,
        compAddr: this.applyContent.companyAddress,
        compTel: this.applyContent.companytel,
        link: this.applyContent.name,
        linkTel: this.applyContent.tel,
        signupDate: this.getNowTime(),
        zt: 0,
      };

      params.biddingsignup = this.current.title;
      params.type = 1;

      service.getwzBiddingNotice(params, (res) => {
        if (res.message == "保存成功") {
          this.$message({
            message: "报名成功",
            type: "success",
          });
        } else {
          this.$message({
            message: "报名失败,请联系管理员",
            type: "error",
          });
        }
        this.applyContent = {
          name: "",
          tel: "",
          companyName: "",
          companyAddress: "",
          companytel: "",
        };
      });
    },
    getNowTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let monthStr = month >= 10 ? month : "0" + month;
      let day = date.getDate();
      let dayStr = day >= 10 ? day : "0" + day;
      let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minute =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let second =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

      return (
        year +
        "-" +
        monthStr +
        "-" +
        dayStr +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second
      );
    },
    // 上一篇 下一篇
    handleChangePage(id) {
      const query = JSON.parse(JSON.stringify(this.$route.query)); // 获取路由参数信息
      query.id = id; //改变参数
      this.$router.push({ path: this.$route.path, query }); //更新路由
      this.init(id);
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style>
</style>

